import React from "react";
import Loading from "../../components/Loading/Loading";

export default function Complete() {
  return <Loading />;
}
